'use strict';

const makeItem = (entry) => {
    return {
        value: {
            system: 'http://snomed.info/sct',
            display: entry.display,
            code: entry.code.toString()
        },
        label: entry.label,
        mobileLabel: entry.mobileLabel,
        level: entry.level
    };
};

const codes = [
    {
        code: 1641000175108,
        display: 'Applicator - unit of product usage (qualifier value)',
        label: 'Applicator',
        mobileLabel: 'Applicator',
        level: 1
    },
    {
        code: 428672001,
        display: 'Bag - unit of product usage (qualifier value)',
        label: 'Bag',
        mobileLabel: 'Bag',
        level: 1
    },
    {
        code: 419672006,
        display: 'Bottle - unit of product usage (qualifier value)',
        label: 'Bottle',
        mobileLabel: 'Bottle',
        level: 1
    },
    {
        code: 418445004,
        display: 'Box - unit of product usage (qualifier value)',
        label: 'Box',
        mobileLabel: 'Box',
        level: 1
    },
    {
        code: 429308001,
        display: 'Can - unit of product usage (qualifier value)',
        label: 'Can',
        mobileLabel: 'Can',
        level: 1
    },
    {
        code: 428641000,
        display: 'Capsule - unit of product usage (qualifier value)',
        label: 'Capsule',
        mobileLabel: 'Capsule',
        level: 1
    },
    {
        code: 428178003,
        display: 'Cup - unit of product usage (qualifier value)',
        label: 'Cup',
        mobileLabel: 'Cup',
        level: 1
    },
    {
        code: 404218003,
        display: 'Drop - unit of product usage (qualifier value)',
        label: 'Drops',
        mobileLabel: 'Drops',
        level: 1
    },
    {
        code: 700476008,
        display: 'Enema - unit of product usage (qualifier value)',
        label: 'Enema',
        mobileLabel: 'Enema',
        level: 1
    },
    {
        code: 429587008,
        display: 'Lozenge - unit of product usage (qualifier value)',
        label: 'Lozenge',
        mobileLabel: 'Lozenge',
        level: 1
    },
    {
        code: 1681000175101,
        display: 'Package - unit of product usage (qualifier value)',
        label: 'Package',
        mobileLabel: 'Package',
        level: 1
    },
    {
        code: 419888008,
        display: 'Packet - unit of product usage (qualifier value)',
        label: 'Packet',
        mobileLabel: 'Packet',
        level: 1
    },
    {
        code: 421823004,
        display: 'Pad - unit of product usage (qualifier value)',
        label: 'Pad',
        mobileLabel: 'Pad',
        level: 1
    },
    {
        code: 419702001,
        display: 'Patch - unit of product usage (qualifier value)',
        label: 'Patch',
        mobileLabel: 'Patch',
        level: 1
    },
    {
        code: 415215001,
        display: 'Puffs',
        label: 'Puffs',
        mobileLabel: 'Puffs',
        level: 1
    },
    {
        code: 2741000175105,
        display: 'Pump - unit of product usage (qualifier value)',
        label: 'Pump',
        mobileLabel: 'Pump',
        level: 1
    },
    {
        code: 415505006,
        display: 'Scoops',
        label: 'Scoops',
        mobileLabel: 'Scoops',
        level: 1
    },
    {
        code: 419694003,
        display: 'Spray - unit of product usage (qualifier value)',
        label: 'Spray',
        mobileLabel: 'Spray',
        level: 1
    },
    {
        code: 1691000175103,
        display: 'Stick - unit of product usage (qualifier value)',
        label: 'Stick',
        mobileLabel: 'Stick',
        level: 1
    },
    {
        code: 1671000175104,
        display: 'Strip - unit of product usage (qualifier value)',
        label: 'Strip',
        mobileLabel: 'Strip',
        level: 1
    },
    {
        code: 430293001,
        display: 'Suppository - unit of product usage (qualifier value)',
        label: 'Suppository',
        mobileLabel: 'Suppository',
        level: 1
    },
    {
        code: 420401004,
        display: 'Swab - unit of product usage (qualifier value)',
        label: 'Swab',
        mobileLabel: 'Swab',
        level: 1
    },
    {
        code: 700474006,
        display: 'Prefilled syringe - unit of product usage (qualifier value)',
        label: 'Prefilled Syringe',
        mobileLabel: 'Prefilled Syringe',
        level: 1
    },
    {
        code: 428673006,
        display: 'Tablet - unit of product usage (qualifier value)',
        label: 'Tablet',
        mobileLabel: 'Tablet',
        level: 1
    },
    {
        code: 415702006,
        display: 'Tbsp',
        label: 'Tbsp',
        mobileLabel: 'Tablespoon',
        level: 1
    },
    {
        code: 415703001,
        display: 'Teaspoonful - unit of product usage (qualifier value)',
        label: 'Tsp',
        mobileLabel: 'Teaspoon',
        level: 1
    },
    {
        code: 418530008,
        display: 'Tube - unit of product usage (qualifier value)',
        label: 'Tube',
        mobileLabel: 'Tube',
        level: 1
    },
    {
        code: 415818006,
        display: 'Vial - unit of product usage (qualifier value)',
        label: 'Vial',
        mobileLabel: 'Vial',
        level: 1
    },
    {
        code: 1701000175103,
        display: 'Wafer - unit of product usage (qualifier value)',
        label: 'Wafer',
        mobileLabel: 'Wafer',
        level: 1
    },
    {
        code: 413516001,
        display: 'Ampule - unit of product usage (qualifier value)',
        label: 'Ampule',
        mobileLabel: 'Ampule',
        level: 2
    },
    {
        code: 413568008,
        display: 'Application - unit of product usage (qualifier value)',
        label: 'Application',
        mobileLabel: 'Application',
        level: 2
    },
    {
        code: 1651000175105,
        display: 'Applicatorful - unit of product usage (qualifier value)',
        label: 'Applicatorfull',
        mobileLabel: 'Applicatorfull',
        level: 2
    },
    {
        code: 428003006,
        display: 'Bar - unit of product usage (qualifier value)',
        label: 'Bar',
        mobileLabel: 'Bar',
        level: 2
    },
    {
        code: 418836005,
        display: 'Base - unit of product usage (qualifier value)',
        label: 'Base',
        mobileLabel: 'Base',
        level: 2
    },
    {
        code: 425565005,
        display: 'Blister - unit of product usage (qualifier value)',
        label: 'Blister',
        mobileLabel: 'Blister',
        level: 2
    },
    {
        code: 413769002,
        display: 'Case - unit of product usage (qualifier value)',
        label: 'Case',
        mobileLabel: 'Case',
        level: 2
    },
    {
        code: 427678004,
        display: 'Disc - unit of product usage (qualifier value)',
        label: 'Disc',
        mobileLabel: 'Disc',
        level: 2
    },
    {
        code: 700478009,
        display: 'Dressing - unit of product usage',
        label: 'Dressing',
        mobileLabel: 'Dressing',
        level: 2
    },
    {
        code: 421954001,
        display: 'Dropperful - unit of product usage (qualifier value)',
        label: 'Dropperful',
        mobileLabel: 'Dropperful',
        level: 2
    },
    {
        code: 426198001,
        display: 'Dual dose sachet - unit of product usage (qualifier value)',
        label: 'Dual dose sachet',
        mobileLabel: 'Dual dose sachet',
        level: 2
    },
    {
        code: 421496007,
        display: 'Glassful - unit of product usage (qualifier value)',
        label: 'Glassful',
        mobileLabel: 'Glassful',
        level: 2
    },
    {
        code: 430281005,
        display: 'Gum - unit of product usage (qualifier value)',
        label: 'Gum',
        mobileLabel: 'Gum',
        level: 2
    },
    {
        code: 428177008,
        display: 'Implant - unit of product usage (qualifier value)',
        label: 'Implant',
        mobileLabel: 'Implant',
        level: 2
    },
    {
        code: 422237004,
        display: 'Inhalation - unit of product usage (qualifier value)',
        label: 'Inhalation',
        mobileLabel: 'Inhalation',
        level: 2
    },
    {
        code: 428639001,
        display: 'Insert - unit of product usage (qualifier value)',
        label: 'Insert',
        mobileLabel: 'Insert',
        level: 2
    },
    {
        code: 419179001,
        display: 'Kit - unit of product usage (qualifier value)',
        label: 'Kit',
        mobileLabel: 'Kit',
        level: 2
    },
    {
        code: 700473000,
        display: 'Pastille - unit of product usage (qualifier value)',
        label: 'Pastille',
        mobileLabel: 'Pastille',
        level: 2
    },
    {
        code: 428640004,
        display: 'Pellet - unit of product usage (qualifier value)',
        label: 'Pellet',
        mobileLabel: 'Pellet',
        level: 2
    },
    {
        code: 700480003,
        display: 'Rectal capsule - unit of product usage (qualifier value)',
        label: 'Rectal capsule',
        mobileLabel: 'Rectal capsule',
        level: 2
    },
    {
        code: 700481004,
        display: 'Rectal tablet - unit of product usage (qualifier value)',
        label: 'Rectal tablet',
        mobileLabel: 'Rectal tablet',
        level: 2
    },
    {
        code: 426148002,
        display: 'Sachet - unit of product usage (qualifier value)',
        label: 'Sachet',
        mobileLabel: 'Sachet',
        level: 2
    },
    {
        code: 429671000,
        display: 'Sponge - unit of product usage (qualifier value)',
        label: 'Sponge',
        mobileLabel: 'Sponge',
        level: 2
    },
    {
        code: 1661000175107,
        display: 'Squirt - unit of product usage (qualifier value)',
        label: 'Squirt',
        mobileLabel: 'Squirt',
        level: 2
    },
    {
        code: 700479001,
        display: 'Sublingual tablet - unit of product usage (qualifier value)',
        label: 'Sublingual tablet',
        mobileLabel: 'Sublingual tablet',
        level: 2
    },
    {
        code: 700477004,
        display: 'Tampon - unit of product usage (qualifier value)',
        label: 'Tampon',
        mobileLabel: 'Tampon',
        level: 2
    },
    {
        code: 700483001,
        display: 'Vaginal capsule - unit of product usage (qualifier value)',
        label: 'Vaginal capsule',
        mobileLabel: 'Vaginal capsule',
        level: 2
    },
    {
        code: 700472005,
        display:
            'Vaginal suppository - unit of product usage (qualifier value)',
        label: 'Vaginal suppository',
        mobileLabel: 'Vaginal suppository',
        level: 2
    },
    {
        code: 700482006,
        display: 'Vaginal tablet - unit of product usage (qualifier value)',
        label: 'Vaginal tablet',
        mobileLabel: 'Vaginal tablet',
        level: 2
    }
];

/* eslint-disable */
const oldCodes = [
  {
    'code': 'Aero',
    'label': 'Aerosol'
  },
  {
    'code': 'Cap',
    'label': 'Capsule'
  },
  {
    'code': 'Chew',
    'label': 'Tablet, Chewable'
  },
  {
    'code': 'Conc',
    'label': 'Concentrate'
  },
  {
    'code': 'Cp12',
    'label': 'Capsule, Sust. Release 12 hr'
  },
  {
    'code': 'Cp24',
    'label': 'Capsule, Sust. Release 24 hr'
  },
  {
    'code': 'CpSR',
    'label': 'Capsule, Sustained Release'
  },
  {
    'code': 'CpDR',
    'label': 'Capsule, Delayed Release(E.C.)'
  },
  {
    'code': 'CpSP',
    'label': 'Capsule, Sprinkle'
  },
  {
    'code': 'Crea',
    'label': 'Cream'
  },
  {
    'code': 'Devi',
    'label': 'Device'
  },
  {
    'code': 'Elix',
    'label': 'Elixir'
  },
  {
    'code': 'Emul',
    'label': 'Emulsion'
  },
  {
    'code': 'Enem',
    'label': 'Enema'
  },
  {
    'code': 'Film',
    'label': 'Film'
  },
  {
    'code': 'Foam',
    'label': 'Foam'
  },
  {
    'code': 'Gas',
    'label': 'Gas'
  },
  {
    'code': 'Gel',
    'label': 'Gel'
  },
  {
    'code': 'Gran',
    'label': 'Granules'
  },
  {
    'code': 'Gum',
    'label': 'Gum'
  },
  {
    'code': 'Inha',
    'label': 'Inhaler'
  },
  {
    'code': 'Inj',
    'label': 'Injectable'
  },
  {
    'code': 'Kit',
    'label': 'Kit'
  },
  {
    'code': 'Liqd',
    'label': 'Liquid'
  },
  {
    'code': 'Lotn',
    'label': 'Lotion'
  },
  {
    'code': 'Lozg',
    'label': 'Lozenge'
  },
  {
    'code': 'Misc',
    'label': 'Misc'
  },
  {
    'code': 'Nebu',
    'label': 'Solution for Nebulization'
  },
  {
    'code': 'Oil',
    'label': 'Oil'
  },
  {
    'code': 'Oint',
    'label': 'Ointment'
  },
  {
    'code': 'Pack',
    'label': 'Packet'
  },
  {
    'code': 'Powd',
    'label': 'Powder'
  },
  {
    'code': 'Pste',
    'label': 'Paste'
  },
  {
    'code': 'PT24',
    'label': 'Patch 24 hr'
  },
  {
    'code': 'PT72',
    'label': 'Patch 72 hr'
  },
  {
    'code': 'PTWK',
    'label': 'Patch Weekly'
  },
  {
    'code': 'Sham',
    'label': 'Shampoo'
  },
  {
    'code': 'Shee',
    'label': 'Sheet'
  },
  {
    'code': 'SolG',
    'label': 'Gel Forming Solution'
  },
  {
    'code': 'Soln',
    'label': 'Solution'
  },
  {
    'code': 'SolR',
    'label': 'Recon Soln'
  },
  {
    'code': 'Stck',
    'label': 'Stick'
  },
  {
    'code': 'Strp',
    'label': 'Strip'
  },
  {
    'code': 'Subl',
    'label': 'Tablet, Sublingual'
  },
  {
    'code': 'Supp',
    'label': 'Suppository'
  },
  {
    'code': 'Susp',
    'label': 'Suspension'
  },
  {
    'code': 'SusR',
    'label': 'Suspension for Reconstitution'
  },
  {
    'code': 'Swab',
    'label': 'Swab'
  },
  {
    'code': 'Syrp',
    'label': 'Syrup'
  },
  {
    'code': 'Tab',
    'label': 'Tablet'
  },
  {
    'code': 'Tb12',
    'label': 'Tablet Sustained Release 12 hr'
  },
  {
    'code': 'Tb24',
    'label': 'Tablet Sustained Release 24 hr'
  },
  {
    'code': 'TbSR',
    'label': 'Tablet Sustained Release'
  },
  {
    'code': 'TbEC',
    'label': 'Tablet, Delayed Release (E.C.)'
  },
  {
    'code': 'TbEF',
    'label': 'Tablet, Effervescent'
  },
  {
    'code': 'Test',
    'label': 'Diagnostic Test'
  },
  {
    'code': 'Tinc',
    'label': 'Tincture'
  },
  {
    'code': 'Troc',
    'label': 'Troche'
  },
  {
    'code': 'Drop',
    'label': 'Drops'
  },
  {
    'code': 'Cmpk',
    'label': 'Combo Pack'
  },
  {
    'code': 'TbTQ',
    'label': 'Tab Sust.Rel. Particle/Crystal'
  },
  {
    'code': 'Syrg',
    'label': 'Syringe'
  },
  {
    'code': 'Clsr',
    'label': 'Cleanser'
  },
  {
    'code': 'Spry',
    'label': 'Spray, Non-Aerosol'
  },
  {
    'code': 'SprA',
    'label': 'Aerosol, Spray'
  },
  {
    'code': 'Dpet',
    'label': 'Dropperette'
  },
  {
    'code': 'Spge',
    'label': 'Sponge'
  },
  {
    'code': 'PadM',
    'label': 'Pads, Medicated'
  },
  {
    'code': 'Mwsh',
    'label': 'Mouthwash'
  },
  {
    'code': 'PtMd',
    'label': 'Adhesive Patch, Medicated'
  },
  {
    'code': 'SolP',
    'label': 'Parenteral Solution'
  },
  {
    'code': 'PgBk',
    'label': 'Piggyback'
  },
  {
    'code': 'DsPk',
    'label': 'Tablets, Dose Pack'
  },
  {
    'code': 'TbDL',
    'label': 'Tablet, Rapid Dissolve'
  },
  {
    'code': 'DrpS',
    'label': 'Drops, Suspension'
  },
  {
    'code': 'TbOm',
    'label': 'Tab, Sust Release Osmotic Push'
  },
  {
    'code': 'C24P',
    'label': 'Cap,24 hr Sust Release Pellets'
  },
  {
    'code': 'CpDv',
    'label': 'Capsule, w/Inhalation Device'
  },
  {
    'code': 'DsDv',
    'label': 'Disk with Device'
  },
  {
    'code': 'SPCA',
    'label': 'Pt Controlled Analgesic Syring'
  },
  {
    'code': 'TO24',
    'label': 'Tab,Sust Rel Osmotic Push 24hr'
  },
  {
    'code': 'Cs24',
    'label': 'Capsule,Sustained Action 24 hr'
  },
  {
    'code': 'CM12',
    'label': 'Cap, Multiphasic Release 12 hr'
  },
  {
    'code': 'InSR',
    'label': 'Insert, Sustained Release'
  },
  {
    'code': 'PwPk',
    'label': 'Powder in Packet'
  },
  {
    'code': 'SpSn',
    'label': 'Spray, Suspension'
  },
  {
    'code': 'TR24',
    'label': 'Tablet Extended Rel 24 hr (b)'
  }
];

module.exports = codes.map(entry => makeItem(entry));
